<template>
  <section
    ref="detailIn"
    class="disease-type-v2-detail"
    :style="'top:' + top + 'px'"
    @scroll="Scroll"
  >
    <div v-if="info.length" class="disease-type-detai-head">
      <ul>
        <li
          v-for="(item, index) in info"
          :key="`ntc_${index}`"
        >
          {{ item }}
        </li>
      </ul>
    </div>
    <ul v-if="list.length" class="disease-type-detail-list">
      <li
        v-for="(item, index) in list"
        :key="`ntn_${index}`"
        @click="showDisease(index)"
      >
        <!-- <p class="tag" v-if="list.length > 1">第{{ index + 1 }}类</p> -->
        <p v-if="list.length > 1" class="title">
          {{ item.name }}
        </p>
        <p v-if="list.length > 1" class="icon">
          <bxs-icon v-if="item.visible" name="arrow-up" />
          <bxs-icon v-else name="arrow-down" />
        </p>
        <dl
          v-for="(child, idx) in item.diseaseDTOS"
          v-show="list.length < 2 ? true : item.visible"
          :key="`ntnc_${idx}`"
          :class="child.visible ? 'visible' : ''"
        >
          <dt @click.stop="showDesc(index, idx)">
            <span v-html="`${child.number}.${replaceAll(child.name)}`" />
            <span v-if="list.length < 2" class="span">
              <bxs-icon name="arrow-up" class="vis-up" />
              <bxs-icon name="arrow-down" class="vis-down" />
            </span>
            <span v-else class="span">
              <b class="vis-up">收起描述</b>
              <b class="vis-down">查看描述</b>
              <em class="vis-up"><bxs-icon name="arrow-up" /></em>
              <em class="vis-down"><bxs-icon name="arrow-down" /></em>
            </span>
          </dt>
          <dd>
            {{ child.description }}
            <span v-if="child.remarks">备注：<br>{{ child.remarks }}</span>
          </dd>
        </dl>
      </li>
    </ul>
    <bxs-default-page v-else type="search" />
  </section>
</template>
<script>
import Vue from 'vue'
import { buriedSubmit } from 'common/js/common'
import { Icon, DefaultPage } from 'bxs-ui-vue'
export default {
  components: { [Icon.name]: Icon, [DefaultPage.name]: DefaultPage },
  props: {
    info: {
      type: Array,
      default: () => []
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isFixed: false
    }
  },
  computed: {
    word() {
      return this.$parent.word
    },
    wordSearch() {
      return this.$parent.wordSearch
    },
    insureList() {
      return this.$parent.list || []
    },
    top() {
      let top = 177
      if (this.insureList.length < 2) top -= 44
      if (this.isFixed) top -= 15
      return top
    }
  },
  methods: {
    showDisease(idx, isFormParent) {
      const item = this.list[idx]
      item.visible = !item.visible
      Vue.set(this.list, idx ,item)
      if (isFormParent) return
      this.$parent.$emit('update', { type: 'check-disease', index: idx})
      buriedSubmit(item.visible ? 'jbxqfzzk' : 'jbxqfzzksq')
    },
    showDesc(parIdx, idx, isFormParent) {
      const item = this.list[parIdx]
      const child = item.diseaseDTOS[idx]
      child.visible = !child.visible
      Vue.set(item.diseaseDTOS, idx ,child)
      if (isFormParent) return
      this.$parent.$emit('update', { type: 'check-desc', parentIndex: parIdx, index: idx})
      buriedSubmit(child.visible ? 'zjxqjbckms' : 'jbxqjbycms')
    },
    reset() {
      this.$refs.detailIn.scrollTop = 0
      this.isFixed = false
      this.$emit('scroll', false)
    },
    Scroll(ev) {
      this.isFixed = ev.target.scrollTop > 5
      this.$emit('scroll', this.isFixed)
    },
    replaceAll(name) {
      if (typeof name !== 'string') return name
      if (!this.wordSearch) return name
      const reg = new RegExp(this.word, 'g')
      return name.replace(reg, '<i>' + this.word + '</i>')
    }
  }
}
</script>
<style>
@import './diseaseTypeNew.css';
</style>